import { DisplayOptions } from 'app/area/favourite/components/display-options';
import { FavouriteReportDownload } from 'app/area/favourite/types';
import { DefaultSortOrder, SharedState } from 'app/types-shared';
import * as React from 'react';
import { Search } from 'ui/search';
import { DomainNode } from 'ui/sort-order/types';

import styles from './favourite.scss';

interface FavouriteSearchProps {
  searchQueryTemp: string;
  translation: any;
  sharedState: SharedState;
  fetchingSortOptions: boolean;
  onChange: (value: string) => void;
  onSearch: () => void;
  loadSortOptions: (query?: string) => void;
  updateSortOptions: (sortOrderFields: DefaultSortOrder[]) => void;
  displayExportToZip: () => void;
  onCreateReport: () => void;
  onUpdateReport: () => void;
  downloadReport: (data: FavouriteReportDownload) => void;
  getMultipleSuppliersUrl: () => void;
  urlMultipleSuppliers: string;
  report: number;
  favouriteId: number;
  reportCategory?: any;
  sortOptions: DomainNode[];
  showUpdate: boolean;
  sortOrderFields?: DefaultSortOrder[];
}

export const FavouriteSearch = ({
  onChange,
  searchQueryTemp,
  onSearch,
  translation,
  loadSortOptions,
  updateSortOptions,
  sharedState,
  onCreateReport,
  onUpdateReport,
  fetchingSortOptions,
  displayExportToZip,
  downloadReport,
  getMultipleSuppliersUrl,
  urlMultipleSuppliers,
  report,
  reportCategory,
  sortOptions,
  favouriteId,
  showUpdate,
  sortOrderFields
}: FavouriteSearchProps) => (
  <div className="row">
    <div className="col-xl-5 col-lg-12">
      <Search
        className={`${styles.searchField} input-wrapper`}
        componentId={'searchFieldId'}
        onChange={onChange}
        value={searchQueryTemp}
        maxLength={255}
        onSearch={onSearch}
        minLength={3}
        placeholder={translation.input_placeholder}
        focus={true}
        wait={0} />
    </div>
    <div className="col-xl-7 col-lg-12">
      <div className={styles.uiDisplayOptions}>
        <DisplayOptions
          translation={translation}
          sharedState={sharedState}
          fetchingSortOptions={fetchingSortOptions}
          loadSortOptions={loadSortOptions}
          updateSortOptions={updateSortOptions}
          displayExportToZip={displayExportToZip}
          showUpdate={showUpdate}
          createReport={onCreateReport}
          updateReport={onUpdateReport}
          downloadReport={downloadReport}
          getMulitpleSuppliersUrl={getMultipleSuppliersUrl}
          urlMultipleSuppliers={urlMultipleSuppliers}
          report={report}
          favouriteId={favouriteId}
          reportCategory={reportCategory}
          sortOptions={sortOptions}
          sortOrderFields={sortOrderFields}
        />
      </div>
    </div>
  </div>
);
